const listeners = new Set<(botId: string) => void>();

/** Settings and the computer list both hear routine create, update, and delete. */
export function subscribeRoutineChanges(listener: (botId: string) => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifyRoutineChanges(botId: string): void {
  for (const listener of listeners) listener(botId);
}
